module.exports = __webpack_public_path__ + "img/forest.ee1ba479.jpeg";